var mentions_default = {
  "mentionPalette": "_0-vod",
  "mention": "pDumj",
  "mentionViewer": "mxKXK",
  "mentionSuggestionsEntry": "etLMP",
  "mentionSuggestionsEntryFocused": "_5b2SB",
  "mentionSuggestionsEntryText": "vHvSN",
  "mentionSuggestionsEntryAvatar": "DWjlL",
  "mentionSuggestions": "-lSM9",
  "cursorDefault": "Pk9X-",
  "cursorPointer": "wo5pS"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
